module.exports = __webpack_public_path__ + "ed23685339ada1b6d88008cbe1a11e98.gif";


//////////////////
// WEBPACK FOOTER
// ./src/containers/loader.gif
// module id = ./src/containers/loader.gif
// module chunks = 0